import Routing from "./Routing";
import TagManager from 'react-gtm-module';

if(!window.location.href.includes("local")){
  const tagManagerArgs ={
    gtmId : process.env.REACT_APP_GTM_ID
  }
  TagManager.initialize(tagManagerArgs);
}


function App() {
  return (
    <>
    <Routing/>
    </>
  );
}

export default App;
